module.exports = __webpack_public_path__ + "static/media/SplashBackground.6d07d2f7.png";